import { environment } from "../../../environments/environment"

const endpointURL = environment.apiEndpoint;
const worldPayEndpointURL = environment.worldPayEndpoint;

//Helper function to construct the full URL
const buildURL = (url: string) => `${endpointURL}/${url}`;
const worldPayBuildUrl = (url: string) => `${worldPayEndpointURL}/${url}`;

//For Local testing use below code 
// const buildURL = (url: string) => `https://localhost:5001/${url}`;

export const adminUrls = {
    'LandingPageContent': { 'url': buildURL('Admin/GetContents') },  
    'LandingPageContentUpdate': { 'url': buildURL('Admin/Contents/SaveContents') },
    'getTabsURL': { 'url': buildURL('Admin/GetTabs') },  
    'EmailContent': { 'url': buildURL('Admin/GetEmailContents') },
    'EmailContentUpdate': { 'url': buildURL('Admin/Email/SaveEmailContents') },
    'SearchURL': { 'url': buildURL('Admin/Reports/Search') },
    'ExportToExcelURL': { 'url': buildURL('Admin/ExportExcel') },
}

export const donationUrls = {
    
    'GetPaymetricAccessTokenURL': { 'url': worldPayBuildUrl('Paymetric/GetPaymetricAccessToken') },
    'ConfirmPaymentURL': { 'url': worldPayBuildUrl('Paymetric/ConfirmPayment') },
    'SendNotification': { 'url': buildURL('Notification/SendNotifications') },
}
